export enum APP_ROUTES {
    ROOT = '/',
    VIEW_APPS_GRID = '/app?page=:page&limit=:limit',
    VIEW_APPS_EDITOR = '/apps',
    VIEW_APPS_EDITOR_PAGE = '/apps?page=:page&limit=:limit',
    ADD_APP = '/addapp',
    APP_DETAILS = '/viewapp/:id',
    APP_DETAILS_PACKAGE = '/viewapp/show?package_name=:packagename',
    EDIT_APP = '/edit/:id',
    ADD_APK = '/addapk/:appid',
    EDIT_APK = '/editapk/:appid/:id',
    VIEW_APK = '/viewapk/:appid/:id',
    LOGIN = '/login',
    USER_VIEW = '/user',
    PAGE404_ERROR = '/404',
    PAGE_NOT_FOUND = '*',
    API = '/api/*',
}

export enum API_ROUTES {
    DOWNLOAD_APK = '/api/application/:appid/apk/:apkid/download',
    UPLOAD_APK = '/application/:appid/apk/:apkid/upload',
    DELETE_APK = '/application/:appid/apk/:apkid/delete',
}
